import { createContext, useContext, useEffect, useState, useCallback } from 'react'
import {
  getBio,
  getExperience,
  getEducation,
  getProjects,
  getBlogList,
  getSkills,
} from '../lib/api.js'

const DataContext = createContext(null)

export function DataProvider({ children }) {
  const [siteData, setSiteData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchAll = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const [bio, experience, education, projects, blogPosts, skills] =
        await Promise.all([
          getBio(),
          getExperience(),
          getEducation(),
          getProjects(),
          getBlogList(),
          getSkills(),
        ])
      setSiteData({ bio, experience, education, projects, blogPosts, skills })
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchAll()
  }, [fetchAll])

  return (
    <DataContext.Provider value={{ data: siteData, loading, error, refetch: fetchAll }}>
      {children}
    </DataContext.Provider>
  )
}

export function useSiteData() {
  const ctx = useContext(DataContext)
  if (!ctx) throw new Error('useSiteData must be used within DataProvider')
  return ctx
}
